(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = root => {
    root.querySelectorAll('[data-halloween-banner]').forEach(banner => {
      if (banner.dataset.motionInitialized) return;
      banner.dataset.motionInitialized = 'true';
      let visible = true;
      const update = () => {
        const running = visible && !document.hidden && !reducedMotion.matches;
        banner.dataset.halloweenMotion = running ? 'running' : 'paused';
      };
      reducedMotion.addEventListener('change', update);
      document.addEventListener('visibilitychange', update);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          update();
        }, { threshold: 0 });
        observer.observe(banner);
      }
      update();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
